/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Intisloweraspect9Inputs */

const de__class_intisloweraspect9 = /** @type {(inputs: _Class_Intisloweraspect9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ist kleiner-gleich`)
};

/**

* @param {_Class_Intisloweraspect9Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_intisloweraspect9 = /** @type {((inputs?: _Class_Intisloweraspect9Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Intisloweraspect9Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_intisloweraspect9(inputs)
});
export { _class_intisloweraspect9 as "_class_IntISLOWERAspect" }